import { useAuth } from "../contexts/AuthContext";
import AccessDeniedPage from "../pages/AccessDeniedPage";

const ProtectedRoute = ({
  children,
  role,
  roles,
  requireAllRoles,
  manualSwapType,
  accessCheck,
  fallback = <AccessDeniedPage />,
  loadingComponent = <div>Loading...</div>,
}) => {
  const {
    isAuthenticated,
    loading,
    isUserInRole,
    hasAnyRole,
    hasAllRoles,
    hasManualSwapAccess,
  } = useAuth();

  if (loading) {
    return loadingComponent;
  }

  if (!isAuthenticated) {
    return fallback;
  }

  let hasAccess = true;

  if (accessCheck) {
    hasAccess = accessCheck();
  } else if (manualSwapType) {
    hasAccess = hasManualSwapAccess(manualSwapType);
  } else if (requireAllRoles && roles) {
    hasAccess = hasAllRoles(roles);
  } else if (roles) {
    hasAccess = hasAnyRole(roles);
  } else if (role) {
    hasAccess = isUserInRole(role);
  }

  return hasAccess ? children : fallback;
};

export default ProtectedRoute;
